// extracted by mini-css-extract-plugin
export default {"wrapper":"Results_wrapper__QcDaa","infoWrapper":"Results_infoWrapper__QDMB7","body1":"Results_body1__M1Na0","button":"Results_button__yihuX"};